import api from './base';

async function fetchList() {
  return await api.call('prices/pdaPrice')
}

async function create(data) {
  return await api.call('prices/pdaPrice', data, 'post')
}

async function updateOne(data) {
  return await api.call('prices/pdaPrice', data, 'put')
}

async function remove(id) {
  return await api.call('prices/pdaPrice', {_id: id}, 'delete')
}

export default {
  fetchList,
  updateOne,
  create,
  remove
}



// WEBPACK FOOTER //
// ./app/services/disbursement.js